"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationType = void 0;
var OperationType;
(function (OperationType) {
    OperationType[OperationType["Call"] = 0] = "Call";
    OperationType[OperationType["DelegateCall"] = 1] = "DelegateCall"; // 1
})(OperationType = exports.OperationType || (exports.OperationType = {}));
//# sourceMappingURL=types.js.map